<!-- Dev Page  /#dev  -->



<template>
  <div id="dev" class="clearfix">

    <div class="panel clearfix">
      <h1>
        Vostock - <strong>v{{ config.VERSION }} [<em>mode={{ config.ENV }}</em>]</strong>
      </h1>


      <div class="dev-controls">
        <button v-on:click="state.toggleColorDisplay()">
          <label v-if="state.colorDisplay">View B/W</label>
          <label v-else>View Color</label>
        </button>
        <button v-on:click="undo"><label>Undo</label></button>
        <button v-on:click="redo"><label>Redo</label></button>
        <button v-on:click="download"><label>Download</label></button>
        <button v-on:click="reset"><label>Reset</label></button>
        <label class="color-picker size-sm" v-bind:style="{ 'background-color': state.color }">
          <input type="color" v-model="state.color">
        </label>
        <input type="number" v-model="state.lineWidth" step="2" min="2" max="32">
      </div>

      <section id="paint">
        <paint></paint>

        <!-- dev palettes -->
        <div class="palette">
          <div class="palette-border">
            <line-widths></line-widths>
          </div>
        </div>

        <div class="palette">
          <div class="palette-border">
            <colors></colors>
          </div>
        </div>

        <div class="palette">
          <div class="palette-border">
            <brushes></brushes>
          </div>
        </div>

      </section>


    </div>

    <!--<div class="panel clearfix">-->
      <!--<screenshots></screenshots>-->
    <!--</div>-->

  </div>
</template>

<style lang="scss">

  @import 'styles/app/colors';

  #dev {
    //overflow: auto;
    //background-color: #234;
    width: auto;

    .panel {
      background-color: #789;
      //margin: 1em auto;
      width: 594px;
      padding: 1em;
    }

    .palette {
      float: left;
      margin: 1em;
    }


    h1 {
      margin: 1em 0;
      line-height: 1em;
    }

    strong {
      color: $color-white;
      font-weight: normal;
    }
    em {
      color: $color-green;
    }


    h1, .dev-controls {
      width: 600px;
      margin: 1em auto;

      > *  {
        vertical-align: top;
      }
    }

    h1 {
      margin-top: 2em;
    }

    section {
      margin: 2em auto;
    }

  }
</style>


<script>
  import Paint from './components/PaintApp'
  //import Screenshots from './components/Screenshots'
  import Colors from './components/palettes/Colors'
  import Brushes from './components/palettes/Brushes'
  import LineWidths from './components/palettes/LineWidths'
  import OpenDialog from './components/palettes/OpenDialog'
  import SaveDialog from './components/palettes/SaveDialog'
  import Share from './components/palettes/Share'

  import config from './data/config'
  import state from './data/state'

  export default {
    data () {
      return {
        state: state,
        config: config,

      }
    },

    components: {
      Paint,
      //Screenshots,
      Colors,
      Brushes,
      LineWidths,
      Share
    },

    methods: {
      download() {
        window.paint.download();
      },
      undo() {
        window.paint.undo();
      },
      redo() {
        window.paint.redo();
      },
      reset() {
        window.paint.clear(true);
      }

    },


    ready () {
      let vm = this;
      //console.log('App is Ready', vm);
      // wait 4 seconds...
      setTimeout(function () {
        // then, go to paint
        //vm.s = 1;
      }, 4000);
    }
  }
</script>



// WEBPACK FOOTER //
// Dev.vue?40273546